
import Carousel from './../../components/Carousel';

import ImageSlider from './../../components/ImageSlider';
import { projects } from './../../static/data';
import References from './../../components/References';
const Home = () => {



    return (
        <div className="bg-gray-200">
            <Carousel />
            <ImageSlider datas={projects} title="Tamamamlanan Projelerimiz" />
            <References />
        </div>
    )
}

export default Home